<template>
  <v-container fluid grid-list-md>
    <h1>Drag and Drop</h1>
    <h4>Elemento adicionado: {{ obj }}</h4>
    <v-layout>
      <v-flex xs2 v-for="agrupador in agrupadores" :key="agrupador">
        <h5>{{ agrupador }}</h5>
        <v-list>
          <draggable
            v-model="myArray"
            group="people"
            @start="drag=true"
            @end="drag=false"
            @change="changeEvt"
            :move="onMoveCallback"
            :id="agrupador"
          >
            <v-list-tile v-for="element in itemsAgrupador(agrupador)" :key="element.id" class="listitem">
              <v-list-tile-content >
                <v-list-tile-title v-html="element.name"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </draggable>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'TestDragDrop',
  components: {
    draggable,
  },
  methods: {
    onMoveCallback(evt, originalEvent){
      this.agrupador = evt.to.id;
      console.log(evt);
    },
    changeEvt(e) {
      if (e && e.added) this.obj = e.added.element;
      console.log(e && e.added ? e.added.element : e);
    },
    itemsAgrupador(agrupador) {
      let items = [];
      items = this.arr.filter(item => item.agrupador == agrupador);
      return items;
    }
  },
  data: () => ({
    obj: null,
    agrupador: '',
    agrupadores: ['INICIO', 'EXECUCAO', 'FINALIZADA'],
    arr: [
      { id: 1, agrupador: 'INICIO', name: 'Newton' },
      { id: 2, agrupador: 'INICIO', name: 'Fred' },
      { id: 3, agrupador: 'INICIO', name: 'Jullyadson' },
      { id: 4, agrupador: 'INICIO', name: 'João' },
      { id: 5, agrupador: 'INICIO', name: 'Emerson' },
      { id: 6, agrupador: 'INICIO', name: 'Gemerson' },
      { id: 7, agrupador: 'INICIO', name: 'Odiley' },
      { id: 8, agrupador: 'FINALIZADA', name: 'Cledesson' },
      { id: 9, agrupador: 'FINALIZADA', name: 'Henrique' },
      { id: 10, agrupador: 'FINALIZADA', name: 'Maciel' },
      { id: 11, agrupador: 'FINALIZADA', name: 'Danilo' },
      { id: 12, agrupador: 'FINALIZADA', name: 'André' },
      { id: 13, agrupador: 'FINALIZADA', name: 'Maurílio' },
      { id: 14, agrupador: 'FINALIZADA', name: 'Davi' },
    ],
    arr2: [
      { id: 8, agrupador: 'FINALIZADA', name: 'Cledesson' },
      { id: 9, agrupador: 'FINALIZADA', name: 'Henrique' },
      { id: 10, agrupador: 'FINALIZADA', name: 'Maciel' },
      { id: 11, agrupador: 'FINALIZADA', name: 'Danilo' },
      { id: 12, agrupador: 'FINALIZADA', name: 'André' },
      { id: 13, agrupador: 'FINALIZADA', name: 'Maurílio' },
      { id: 14, agrupador: 'FINALIZADA', name: 'Davi' },
    ]
  }),
  computed: {
    myArray: {
      get() {
        return this.arr;
      },
      set(v) {
        this.arr = v;
        // console.log(v);
      }
    },
    myArray2: {
      get() {
        return this.arr2;
      },
      set(v) {
        this.arr2 = v;
        // console.log(v);
      }
    }
  }
}
</script>

<style scoped>
.listitem:hover {
  cursor: pointer;
  background: #e5e5e5;
}
</style>